import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import type { Ad } from '../../types';
import { ADS } from '../../constants/testIds';

export function PopupAd({ ad }: { ad: Ad }) {
  const key = `ad_popup_${ad.id}_${ad.updated_at || ad.created_at || 'v'}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) !== '1' && sessionStorage.getItem(key) !== '1');
  if (!open) return null;

  const close = () => { localStorage.setItem(key, '1'); setOpen(false); };
  const isInternal = ad.button_link?.startsWith('/');

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 animate-in fade-in duration-300">
      <div data-testid={ADS.popup} className="relative w-full max-w-md bg-[#090D1A] border border-white/10 rounded-2xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300">
        <button data-testid={ADS.popupClose} onClick={close} className="absolute right-3 top-3 z-10 p-1.5 rounded-lg bg-black/40 text-white/70 hover:text-white hover:bg-black/60">
          <X className="w-4 h-4" strokeWidth={2} />
        </button>
        {ad.image_url && (
          <img src={ad.image_url} alt={ad.title} className="w-full h-44 object-cover" />
        )}
        <div className="p-6">
          <p className="text-xs uppercase tracking-[0.2em] text-cyan-400 mb-2">Pengumuman</p>
          <h3 className="text-xl font-medium text-white mb-2">{ad.title}</h3>
          {ad.content && <p className="text-sm text-white/60 leading-relaxed mb-5">{ad.content}</p>}
          {ad.button_label && ad.button_link && (
            isInternal ? (
              <Link data-testid={ADS.popupCta} to={ad.button_link} onClick={close} className="inline-block bg-cyan-400 text-[#050914] font-medium px-6 py-2.5 rounded-lg transition-colors hover:bg-cyan-300 text-sm">
                {ad.button_label}
              </Link>
            ) : (
              <a data-testid={ADS.popupCta} href={ad.button_link} target="_blank" rel="noreferrer" onClick={close} className="inline-block bg-cyan-400 text-[#050914] font-medium px-6 py-2.5 rounded-lg transition-colors hover:bg-cyan-300 text-sm">
                {ad.button_label}
              </a>
            )
          )}
        </div>
      </div>
    </div>
  );
}
